// extracted by mini-css-extract-plugin
module.exports = {"widget":"SelectWidget_widget__uY3kD","borderless":"SelectWidget_borderless__3aQUc"};